import useTitle from './useTitle';

const PageTitle = ({ title = 'Procure' }) => {
  useTitle(`${title} - Procure`);

  return null;
};

export default PageTitle;
